export enum BuildingPeriods {
    PreWar = 2544,
    PostWar = 2545
}